// import { Poppins } from "next/font/google";

import { Bars3Icon } from "@heroicons/react/24/solid";

// const poppins = Poppins({
//   subsets: ["latin"],
//   variable: "--font-poppins",
//   weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
// });

function Header() {
  return (
    <div className="px-6 fixed top-5 left-0 right-0 z-50 bg-black bg-opacity-50 backdrop-blur-sm shadow-md">
      <div className="items-center justify-center flex align-middle w-full">
        <div
          onClick={() => {
            console.log("Logo clicked");
          }}
          className="flex justify-start w-full"
        >
          <img
            src="/img/logo_trans.png"
            className="h-6 w-6 sm:h-11 sm:w-11"
            alt="Logo"
          />
        </div>

        <h1
          className={`text-[5vw] sm:text-[2.5vw] w-full bg-gradient-to-r from-white via-gray-50 to-slate-200 bg-clip-text text-transparent drop-shadow-lg tracking-widest text-center font-bold `}
        >
          EMOTIONLY
        </h1>

        <div className="flex align-middle gap-6 justify-end w-full items-end">
          <div
            onClick={() => {
              console.log("Discord clicked");
              window.open("https://discord.gg/mm9MG7uEkC", "_blank");
            }}
          >
            <img
              src="/img/discord-logo.png"
              className="h-5 w-5 sm:h-10 sm:w-10"
              alt="Logo"
            />
          </div>

          {/* <Bars3Icon className="h-5 w-5 sm:h-10 sm:w-10 text-white cursor-pointer" /> */}
        </div>
      </div>
    </div>
  );
}

export default Header;
